import React from 'react';
import NavigationBar from '../../components/navbar/component'
import Head from '../../components/head/component'
import Image from '../../image/PracticeAreaCover.png'
import {
    Footer
} from '../../components/footer/components'
import {
    PracticeAreaFourCards
} from '../../components/PracticeArea/practiceAreaFourCards'
import { 
    Bg, 
    Title,
    FirstImage,
    ButtonText,
    FirstCard,
    MiniFirstImage
 } from './style'
import { 
    Card, 
    CardTitle, 
    CardDescription,
    Circle,
    Arrow
} from '../../components/PracticeArea/style'
import { Box, Flex } from 'reflexbox'
import Pic1 from '../../image/practice_area/1.png';
import Pic2 from '../../image/practice_area/2.png';
import Pic3 from '../../image/practice_area/3.png';
import Pic4 from '../../image/practice_area/4.png';
import Pic5 from '../../image/practice_area/5.png';
import Pic6 from '../../image/practice_area/6.png';
import Pic7 from '../../image/practice_area/7.png';
import Pic8 from '../../image/practice_area/8.png';
import Pic9 from '../../image/practice_area/9.png';
import RightArrow from '../../image/right-arrow.png';
import { useScreenSize } from '../../hooks/useScreenSize';

export const PracticeAreaPage = () => {

    const screenSize = useScreenSize();

    return (
        <>
            <NavigationBar />
            <Head 
                imagePath={Image}
                caption='EXCELLENCE IN ADVOCACY INTEGRITY IN PRACTICE'
            />
            <Bg>
                <Card bgColor="#255371" color="#ffffff">
                    {
                        screenSize < 560 ?
                        <div>
                            <div>
                                <MiniFirstImage 
                                    src={Pic1} 
                                    alt="" 
                                />
                            </div>
                            <Flex 
                                flexDirection="row" 
                                marginTop="28px" 
                                marginBottom="16px"
                            >
                            <Flex flexDirection="column" width="100%">
                                <CardTitle>
                                    Bankruptcy & Debt Payment Suspension
                                </CardTitle>
                                <CardDescription>
                                    Sequoia Advocates has extensive experience in handling civil law matters, 
                                    particularly in bankruptcy and debt restructuring. Our team includes licensed
                                    curators and administrators registered with the Indonesian Association of
                                    Curators and Administrators. This expertise allows us to effectively assist clients
                                    with debt restructuring needs.
                                </CardDescription>
                            </Flex>
                            <Flex
                                flexDirection='column' 
                                justifyContent='flex-end'
                            >
                                <Circle>
                                <Arrow src={RightArrow} alt ="" />
                                </Circle>
                            </Flex>
                            </Flex>
                        </div>
                        :
                        <>
                            <FirstCard>
                                <CardTitle>
                                    Bankruptcy & Debt Payment Suspension
                                </CardTitle>
                                <CardDescription>
                                    Sequoia Advocates has extensive experience in handling civil law matters, 
                                    particularly in bankruptcy and debt restructuring. Our team includes licensed
                                    curators and administrators registered with the Indonesian Association of
                                    Curators and Administrators. This expertise allows us to effectively assist clients
                                    with debt restructuring needs.
                                </CardDescription>
                            </FirstCard>
                            <Flex
                                flexDirection='column' 
                                width='37%'
                            >
                                <FirstImage 
                                    src={Pic1} 
                                    alt="" 
                                />
                                <Flex
                                    flexDirection='row' 
                                    justifyContent='flex-end'
                                    width='100%'
                                    height='auto'
                                    paddingRight="16px"
                                    paddingBottom="16px"
                                >
                                    <Circle>
                                        <Arrow 
                                            src={RightArrow} 
                                            alt ="" 
                                        />
                                    </Circle>
                                </Flex>
                            </Flex>
                        </>
                    }
                </Card>
                <Box marginTop='20px'>
                    <PracticeAreaFourCards 
                        firstCard={{
                            title: 'Antitrust Law',
                            description: 'Sequoia Advocates is well-versed in the complexities of competition law, offering strategic legal solutions to protect client interests. We have successfully represented clients in cases before the Indonesian Competition Commission (KPPU).',
                            image: Pic2
                        }}
                        secondCard={{
                            title: 'Commercial Litigation',
                            description: 'With our extensive experience, Sequoia Advocates has a strong understanding of business-related legal issues. We provide services in contract negotiation and drafting, regulatory compliance, corporate restructuring, mergers, acquisitions, and business closures to protect our clients\' interests.',
                            image: Pic3
                        }}
                        thirdCard={{
                            title: 'Intellectual Property Rights',
                            description: 'Intellectual property is crucial for commercial success, and Sequoia Advocates has significant experience in protecting IP rights. We assist with copyright, patent, and trademark registrations and renewals. Our services also cover agency agreements, licensing, franchising, media purchases, and recording contracts.',
                            image: Pic4
                        }}
                        forthCard={{
                            title: 'Arbitration & Dispute Resolution',
                            description: 'We have broad experience in handling cases based on their complexity, from bipartite & tripartite negotiations to legal proceedings. Trusted by both domestic and international clients, we offer legal assistance in negotiation, mediation, civil lawsuits, criminal reports & arbitration both in Indonesia & abroad.',
                            image: Pic5
                        }}
                    />
                </Box>
                <Box marginTop="20px">
                    <PracticeAreaFourCards 
                        firstCard={{
                            title: 'Employment Law',
                            description: 'Sequoia Advocates advises clients on both internal and external employment matters, including legal consultation, restructuring plans, mass termination strategies, and dispute resolution. We also offer services for drafting and negotiating employment contracts, confidentiality agreements, and employment-related litigation.',
                            image: Pic6
                        }}
                        secondCard={{
                            title: 'Administrative Disputes',
                            description: 'Sequoia Advocates has extensive experience in administrative disputes. Government-issued administrative decisions often overlook the negative impacts on affected parties, creating imbalances in legal standing. Our firm is skilled in addressing such legal challenges.',
                            image: Pic7
                        }}
                        thirdCard={{
                            title: 'Intellectual Property Rights',
                            description: 'Intellectual property is crucial for commercial success, and Sequoia Advocates has significant experience in protecting IP rights. We assist with copyright, patent, and trademark registrations and renewals. Our services also cover agency agreements, licensing, franchising, media purchases, and recording contracts.',
                            image: Pic8
                        }}
                        forthCard={{
                            title: 'Family Law',
                            description: 'Legal issues often arise within families, including inheritance disputes, child custody battles, and division of assets. Sequoia Advocates provides expert legal assistance in family law matters and offers services for drafting prenuptial and postnuptial agreements.',
                            image: Pic9
                        }}
                    />
                </Box>
                <Flex 
                    marginTop="80px" 
                    justifyContent="space-between"
                    alignItems="center"
                    flexDirection="column"
                    marginBottom="40px"
                >
                    <Title>
                        Download for Company Profile
                    </Title>
                    <ButtonText>
                        DOWNLOAD HERE 
                    </ButtonText>
                </Flex>
            </Bg>
            <Footer />
        </>
    )
}